import { useEffect, useState } from "react";
import DashboardCard from "../../components/Dahboard-card/DashboardCard";
import APICall from "./../../components/Api/APICall";
import MonthBarGrapghComponent from './pages/Graphs/MonthBarGrapghComponent';
import ProductBarGrapghComponent from './pages/Graphs/ProductBarGrapghComponent';
export default function SuperAdminDashboard() {
  const [AdminDashboardDatList, setAdminDashboardDatList] = useState({});

  const [AdminDashboardCard, setAdminDashboardCard] = useState([]);

  useEffect(() => {
    APICall("/dashboard/count").then((data) => {
      if (data.status) {
        setAdminDashboardDatList(data.message[0]);
      }
    });
  }, []);

  useEffect(() => {
    const temp = [
      {
        title: "Total Customer",
        icon: "",
        iconBg: "",
        data: AdminDashboardDatList.TotalCustommer,
      },
  
      {
        title: "Total Product",
        icon: "shopping-bag",
        iconBg: "bg-yellow-600",
        data: AdminDashboardDatList.TotalService,
      },  {
        title: "Total Udhar",
        icon: "wallet",
        iconBg: "bg-red-600",
        data: AdminDashboardDatList.Udhar,
      },
    ];
    setAdminDashboardCard(temp);
  }, [AdminDashboardDatList]);

  return (
    <>
           {AdminDashboardCard.length > 0 ? (
        <DashboardCard data={AdminDashboardCard} />
      ) : (
        ""
      )}

      
      <div className="flex flex-row flex-wrap flex-grow">
         <div className="w-full md:w-2/3 p-1">
          <div className="bg-white border rounded shadow p-5">
             <MonthBarGrapghComponent/>
          </div>
        </div> 
        <div className="w-full md:w-1/3 p-1">
          <div className="bg-white border rounded shadow">
            <div className="p-5">
             <ProductBarGrapghComponent />
            </div>
          </div>
        </div>
        {/* <div className="w-full md:w-1/2 xl:w-1/3 p-3">
          <div className="bg-white border rounded shadow">
            <div className="border-b p-3">
              <h5 className="font-bold uppercase text-gray-600">Graph</h5>
            </div>
            <div className="p-5">
              <canvas id="chartjs-1" className="chartjs" width="undefined" height="undefined" />
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 xl:w-1/3 p-3">
          <div className="bg-white border rounded shadow">
            <div className="border-b p-3">
              <h5 className="font-bold uppercase text-gray-600">Graph</h5>
            </div>
            <div className="p-5"><canvas id="chartjs-4" className="chartjs" width="undefined" height="undefined" />
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 xl:w-1/3 p-3">
          <div className="bg-white border rounded shadow">
            <div className="border-b p-3">
              <h5 className="font-bold uppercase text-gray-600">Template</h5>
            </div>
            <div className="p-5">
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}
